/**
 * Ops-facing copy for compensation & recovery screens.
 */

export const PAGE = {
  title: "Compensation & recovery",
  subtitle:
    "Use this screen after damage, loss, or a customer promise to repay. Adjustments recover cost from the partner; compensation plans pay the customer on a schedule.",
};

export const BANNER = {
  summary:
    "Two separate flows: (1) Adjustments — who pays Bubakii back (partner vs us). (2) Compensation plans — when and how much the customer receives.",
  recoveryNote:
    "Approved partner adjustments are recovered automatically on future payout runs (capped at 50% of each run’s net by default, so partners keep part of their pay).",
};

export const TABS = {
  adjustments: {
    label: "Adjustments",
    description:
      "Records who is responsible for the cost (partner, Bubakii, or shared). Approving provider/shared adjustments sends an informational email to the partner (preview first) and starts recovery on payout. Does not pay the customer by itself.",
    empty: "No adjustments yet. Create one when you need to assign cost and recover from a partner.",
  },
  plans: {
    label: "Compensation plans",
    description:
      "Schedules money owed to the customer (e.g. R2 500 end of May + R2 500 end of June). Each due installment is paid here with “Pay customer”, which posts a compensation refund on the invoice.",
    empty: "No compensation plans yet.",
    emptyNoInvoice: "Link an invoice to this job before creating a compensation plan.",
  },
};

export const ADJUSTMENT_FORM = {
  title: "Create financial adjustment",
  intro:
    "Use for late incidents after the job was paid. Provider/shared adjustments stay pending until you approve; approval starts partner recovery on payout runs.",
};

export const PLAN_FORM = {
  title: "Customer compensation plan",
  intro:
    "Installment amounts must equal the total. Optionally create a linked pending adjustment — approve it on the Adjustments tab (partner gets an informational email).",
};

export const PLAN_CARD = {
  intro:
    "Customer repayment schedule. Pay each installment when due: upload proof, preview customer email (credit note + proof), optionally send partner FYI if a linked adjustment exists. Finance → Due installments queue lists overdue items.",
};

export const DUE_QUEUE = {
  title: "Due customer compensation",
  intro:
    "Installments with due date on or before the selected date. Open the order to pay the customer; partner recovery (if approved) still runs on payout separately.",
};

export const FINANCE_CARD = {
  title: "Customer compensation",
  body: "Scheduled repayments to customers after damage/loss, plus partner recovery on payout when adjustments are approved.",
  action: "Due installments queue",
};
